export const AGENT_PRIVILEGES = {
  READ_WRITE_FILES: 1,
  READ_ONLY_GITLAB: 2,
  READ_WRITE_GITLAB: 3,
  RUN_COMMANDS: 4,
  USE_GIT: 5,
  RUN_MCP_TOOLS: 6,
};

export const FIX_PIPELINE_AGENT_PRIVILEGES = [
  AGENT_PRIVILEGES.READ_WRITE_FILES,
  AGENT_PRIVILEGES.READ_ONLY_GITLAB,
  AGENT_PRIVILEGES.READ_WRITE_GITLAB,
  AGENT_PRIVILEGES.RUN_COMMANDS,
  AGENT_PRIVILEGES.USE_GIT,
];

export const VULNERABILITY_RESOLUTION_AGENT_PRIVILEGES = [
  AGENT_PRIVILEGES.READ_WRITE_FILES,
  AGENT_PRIVILEGES.READ_ONLY_GITLAB,
  AGENT_PRIVILEGES.READ_WRITE_GITLAB,
  AGENT_PRIVILEGES.RUN_COMMANDS,
  AGENT_PRIVILEGES.USE_GIT,
];

export const RESOLVE_DISCUSSION_AGENT_PRIVILEGES = [
  AGENT_PRIVILEGES.READ_WRITE_FILES,
  AGENT_PRIVILEGES.READ_ONLY_GITLAB,
  AGENT_PRIVILEGES.READ_WRITE_GITLAB,
  AGENT_PRIVILEGES.USE_GIT,
];
